import { createSelector } from "reselect";

export const sparePartReducerSelector = createSelector(
  state => state.get("sparePartReducer"),
  sparePartReducer => sparePartReducer
);

export const parentProductsSelector = createSelector(
  sparePartReducerSelector,
  sparePartReducer => sparePartReducer.getIn(["parentProducts", "data"])
);

export const parentProductsLoadingSelector = createSelector(
  sparePartReducerSelector,
  sparePartReducer => sparePartReducer.getIn(["parentProducts", "isLoading"])
);